import { changeIpList,batchChangeIp,batchChangeIpCheckAccount,ipGroupList,searchChangeIpList } from 'api/changeIp';
import Cookies from 'js-cookie';

const changeIp = {
    state: {
        account: '',
        status: '',
        email: '',
        uid: Cookies.get('uid'),
        acc: Cookies.get('acc'),
        avatar: '',
        introduction: '',
        roles: [],
        setting: {
            articlePlatform: []
        }
    },

    mutations: {

    },

    actions: {
        changeIpList({commit}, params) {
            return new Promise((resolve, reject) => {
                changeIpList(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        batchChangeIp({commit},params) {
            return new Promise((resolve, reject) => {
                batchChangeIp(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        batchChangeIpCheckAccount({commit},params) {
            return new Promise((resolve, reject) => {
                batchChangeIpCheckAccount(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        ipGroupList({commit},params) {
            return new Promise((resolve, reject) => {
                ipGroupList(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        searchChangeIpList({commit},params) {
            return new Promise((resolve, reject) => {
                searchChangeIpList(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
    }
};

export default changeIp;



// WEBPACK FOOTER //
// ./src/store/modules/changeIp.js